import { render, staticRenderFns } from "./navdetail.vue?vue&type=template&id=49b28e65&scoped=true"
import script from "./navdetail.vue?vue&type=script&lang=js"
export * from "./navdetail.vue?vue&type=script&lang=js"
import style0 from "./navdetail.vue?vue&type=style&index=0&id=49b28e65&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b28e65",
  null
  
)

export default component.exports